import { nanoid } from 'nanoid'

const createMock = (i) => ({
  id: nanoid(),
  isActive: false,
  values: [
    { data: '12.01.2021' },
    { data: '12.03.2021' },
    { data: `Проект ${i + 1000}` },
    { data: `Тестовый текст ${i + 1000}` },
    { data: 'Петр Петров' },
    { data: i + 1000 },
    { data: 'Тестовый текст 1234' },
    { data: i + 1000 },
    { data: '123' },
    { data: i + 1000 },
    { data: 'Тестовый текст 1234' }
  ]
})

export const createMock2 = values => ({
  id: nanoid(),
  isActive: false,
  values
})

const user = {
  profile: {
    full_name: 'Администратор @admin'
  },
  avatar: {
    url: '/img/avatar-thumb.png'
  }
}
const countFiles = {
  count: '8 файлов'
}

const createMock3 = (i) => ({
  id: nanoid(),
  isActive: false,
  values: [
    { data: `${i + 1}` },
    { data: 'Приказ' },
    { data: 'Тест тема' },
    { data: '123' },
    { data: '10.03.2022' },
    { data: user, mod: 'avatar' },
    { data: user, mod: 'avatar' },
    { data: countFiles, mod: 'countFiles' }
  ]
})

// стройка
export const MOCKS_CONSTRUCTING = Array.from({ length: 5 }).map((_, i) =>
  createMock(i)
)

// приказы
export const MOCKS_DECREES = Array.from({ length: 20 }).map((_, i) => createMock3(i))

// объект
export const objectValues = [
  { data: '12.01.2021' },
  { data: '12.03.2021' },
  { data: 'Петр Петров' },
  { data: '1234' },
  { data: 'Тестовый текст 1234' },
  { data: 'Петр Петров' },
  { data: 'Тестовый текст 1234' },
  { data: 'Петр Петров' },
  { data: 1234 },
  { data: 1234 }
]

export const MOCKS_OBJECTS = Array.from({ length: 20 }).map(() => createMock2(objectValues))

// проект
export const projectValues = [
  { data: '12.01.2021' },
  { data: '12.06.2021' },
  { data: '11.01.2021' },
  { data: 'Петр Петров' },
  { data: 'Стройка 1234' },
  { data: 'Объект 1234' },
  { data: 1234 },
  { data: 'Наименование 1234' },
  { data: 'Петр Петров' },
  { data: 'Петр Петров' },
  { data: 1234 },
  { data: 1234 },
  { data: 1234 },
  { data: 1234 },
  { data: 'в работе' }
]

export const MOCKS_PROJECTS = Array.from({ length: 20 }).map(() => createMock2(projectValues))

// проект - реестр изменений
export const reesterOfChangesValues = [
  { data: 123 },
  { data: '12.06.2021' },
  { data: 'Без сметы' },
  { data: 'Петр петров' },
  { data: '12.06.2021' },
  { data: 'Текстовый текст' },
  { data: '8 файлов' }
]

export const MOCKS_REGISTEROFCHANGES = Array.from({ length: 20 }).map(() => createMock2(reesterOfChangesValues))

// проект - документы
export const documentsValues = [
  { data: 'Наименование документа' },
  { data: '12.06.2021' },
  { data: 'Анулированно' },
  { data: 'Петр петров' },
  { data: 'Смета' },
  { data: 'Текстовый текст' }
]

export const MOCKS_DOCUMENTS = Array.from({ length: 20 }).map(() => createMock2(documentsValues))

// проект - журнал изменений
export const changelogValues = [
  { data: '28.07.2021/15:44' },
  { data: 'Петр Петров' },
  { data: 'Смета' },
  { data: 'Изменение цены' },
  { data: '20 000' },
  { data: '30 000' }
]

export const MOCKS_CHANGELOG = Array.from({ length: 20 }).map(() => createMock2(changelogValues))

// проект - деф. Ведомости
export const statementValues = [
  { data: 123 },
  { data: '12.06.2021' },
  { data: 'Анулированно' },
  { data: 123 },
  { data: '8 файлов' },
  { data: 'Текстовый текст' }
]

export const MOCKS_STATEMENTS = Array.from({ length: 20 }).map(() => createMock2(statementValues))

// проект - работы

export const projectsJobsValues = [
  { data: '12.07.2021' },
  { data: 'Текстовый' },
  { data: 'Текстовый текст 1234' },
  { data: 123 },
  { data: 'м3;' },
  { data: 'Петр Петров' },
  { data: '12.06.2021' },
  { data: '12.12.2021' },
  { data: 123 },
  { data: 'Текстовый текст' },
  { data: 123 }
]

export const MOCKS_PROJECTS_JOBS = Array.from({ length: 20 }).map(() => createMock2(projectsJobsValues))

// проект - планирование

export const planningValues = [
  { data: 'Месяц' },
  { data: 123 },
  { data: 123 },
  { data: 1234 },
  { data: 1234 }
]

export const MOCKS_PLANNING = Array.from({ length: 12 }).map(() => createMock2(planningValues))

// проект - КМД

export const kmdValues = [
  { data: '12.03.2021' },
  { data: 'Организация' },
  { data: '12.03.2021' },
  { data: 1234 },
  { data: 1234 },
  { data: 1234 },
  { data: 'Текстовый текст 1234' },
  { data: 'Документ.PDF' }
]

export const MOCKS_KMD = Array.from({ length: 20 }).map(() => createMock2(kmdValues))

// проект - Снабжение

export const deliveryValues = [
  { data: 'Текстовый' },
  { data: 'Текстовый тескт 1234' },
  { data: 123 },
  { data: 'м3;' },
  { data: 'Петр Петров' },
  { data: '5 заявок' }
]

export const MOCKS_DELIVERY = Array.from({ length: 20 }).map(() => createMock2(deliveryValues))

// проект - снабжение - номенклатура

export const nomenclatureValues = [
  { data: 'Текстовый' },
  { data: 'м3;' },
  { data: 123 },
  { data: 'Текстовый текст 1234' }
]

export const MOCKS_NOMENCLATURE = Array.from({ length: 10 }).map(() => createMock2(nomenclatureValues))

// проект - Сметный

export const estimateValues = [
  { data: 1235 },
  { data: 'Смета 123' },
  { data: 'Петр петров' },
  { data: '12.03.2021' },
  { data: 'М32788.02-КМ1.ЛС' },
  { data: '10 000, 00' },
  { data: '15 000' },
  { data: '8,00' },
  { data: '32 000, 00' },
  { data: 132 }
]

export const MOCKS_ESTIMATES = Array.from({ length: 10 }).map(() => createMock2(estimateValues))

// проект - Подписание работ

export const signValues = [
  { data: '0.5 т' },
  { data: '150 000' },
  { data: '150 000' },
  { data: '150 000' },
  { data: '150 000' },
  { data: '150 000' },
  { data: 'Февраль 2021' },
  { data: 123 },
  { data: 'Нет' },
  { data: 132 },
  { data: 132 }
]

export const MOCKS_SIGN = Array.from({ length: 10 }).map(() => createMock2(signValues))

// проект - собственное производство

export const ownProdValues = [
  { data: 'БРУ' },
  { data: 'Бетон' },
  { data: 123 },
  { data: '150 000' },
  { data: '150 000' },
  { data: 'Текстовый текст' }
]

export const MOCKS_OWNPROD = Array.from({ length: 10 }).map(() => createMock2(ownProdValues))

// проект - ППР

export const pprValues = [
  { data: '12.03.2021' },
  { data: 'Наименование ППР' },
  { data: 'Разработчик ППР' },
  { data: 'Документ.PDF' }
]

export const MOCKS_PPR = Array.from({ length: 20 }).map(() => createMock2(pprValues))

// ПТО - Виды работ

export const jobsList = [
  [{ data: 'Земляные работы' }],
  [{ data: 'Демонтажные работы' }],
  [{ data: 'Железобетонные работы' }],
  [{ data: 'Изготовление м/к' }],
  [{ data: 'Монтаж м/к' }],
  [{ data: 'Кровельные работы' }],
  [{ data: 'Заполнение оконных и дверных проем' }],
  [{ data: 'Свайные работы' }],
  [{ data: 'Монтаж аспирации' }],
  [{ data: 'Монтаж системы видеонаблюдения' }],
  [{ data: 'Внутреннее электроснабжение' }],
  [{ data: 'Строительсво подстанций' }],
  [{ data: 'Наружнее электроснабжение' }],
  [{ data: 'Заземление и молниезащита' }],
  [{ data: 'Монтаж оборудования' }],
  [{ data: 'Внутренние сети водоснабжения и канализации' }],
  [{ data: 'Наружные сети водоснабжения и канализации' }],
  [{ data: 'Тепловые сети' }],
  [{ data: 'Наружные сети газоснабжения' }],
  [{ data: 'Внутренние сети газоснабжения' }],
  [{ data: 'Технологическое оборудование и технологические трубопроводы' }],
  [{ data: 'Отопление' }],
  [{ data: 'Ливневая канализация' }],
  [{ data: 'Футеровочные работы' }],
  [{ data: 'Рубка ж/б' }],
  [{ data: 'Наружное освещение' }],
  [{ data: 'ПНР' }],
  [{ data: 'ОПС' }],
  [{ data: 'АСУ' }],
  [{ data: 'Сети связи' }],
  [{ data: 'Отделочные работы' }],
  [{ data: 'Устройство фасада' }],
  [{ data: 'Огнезащита' }],
  [{ data: 'Вентиляция' }],
  [{ data: 'Реконструкция' }],
  [{ data: 'АКЗ' }]
]

export const MOCKS_JOBS_LIST = jobsList.map(job => createMock2(job))
